import { MainLayoutSimple } from "components/layouts/MainLayoutSimple";
import { AppRouteType } from "navigation/registryRoutes";
import slugs from "navigation/slugs";
import ProfileBalance from "../page/ProfileBalance";

const routes: AppRouteType[] = [
  {
    path: slugs.profileBalance,
    component: ProfileBalance,
    container: MainLayoutSimple,
    isAuthNeeded: true,
  },
];

export default routes;
